var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20.998,
    viewBox: "0 0 21 20.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "website",
    d: "M21.612,14.138a10.278,10.278,0,0,0,.35-2.664A10.489,10.489,0,1,0,11.473,21.962a10.278,10.278,0,0,0,2.664-.35.69.69,0,0,0,.566.371h.042a.694.694,0,0,0,.629-.4l2-4.209,4.209-2a.689.689,0,0,0,.028-1.238Zm-2.084-6.86h-3.14a26.837,26.837,0,0,0-1.049-4.021A9.148,9.148,0,0,1,19.528,7.278ZM9.312,2.656a8.7,8.7,0,0,1,4.321,0,26.154,26.154,0,0,1,1.336,4.622H7.976A24.714,24.714,0,0,1,9.312,2.656ZM7.6,3.265A25.533,25.533,0,0,0,6.55,7.278H3.417A9.083,9.083,0,0,1,7.6,3.265ZM2.382,11.474a9.012,9.012,0,0,1,.448-2.8H6.347a24.141,24.141,0,0,0,0,5.594H2.83A9.012,9.012,0,0,1,2.382,11.474Zm1.035,4.2H6.55A25.533,25.533,0,0,0,7.6,19.683,9.083,9.083,0,0,1,3.417,15.669ZM7.76,8.677h7.433a22.444,22.444,0,0,1,.168,3.356L11.7,10.809a.7.7,0,0,0-.888.888l.86,2.573H7.76a22.688,22.688,0,0,1,0-5.594Zm3.713,11.887a8.794,8.794,0,0,1-2.161-.273,24.714,24.714,0,0,1-1.336-4.622h4.16l1.538,4.622A8.882,8.882,0,0,1,11.473,20.564Zm5.076-4.349a.711.711,0,0,0-.336.336l-1.357,2.867L13.284,14.7l-.706-2.119,6.839,2.28Zm3.741-2.538-3.545-1.182A23.222,23.222,0,0,0,16.6,8.677h3.517a9.012,9.012,0,0,1,.448,2.8A8.882,8.882,0,0,1,20.29,13.676Z",
    transform: "translate(-0.984 -0.985)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteColored);
export default __webpack_public_path__ + "static/media/website-colored.ff778a2efa3ecdd653f2eca03ad2a60a.svg";
export { ForwardRef as ReactComponent };